import classnames from 'classnames';
import { useMemo, useState } from 'react';
import { $a } from 'shared-base';
import { useFuzzySearchQ } from '../../hooks/useFuzzySearch';
import Search from '../Search/Search';
import VirtualGallery from '../VirtualGallery/VirtualGallery';
import { itemActions } from './BackdropBrowser.data';
import { Content, Row, Wrapper } from './BackdropBrowser.style';

export type BackdropBrowserProps = {
  backdrops: IShader[];
  isLoading: boolean;
  onAction: OnAction;
  children?: React.ReactNode;
  spawn: boolean;
};

export function BackdropBrowser(props: BackdropBrowserProps) {
  const { backdrops, isLoading, spawn } = props;
  const [category, setCategrory] = useState('all');
  const [style, setStyle] = useState('all');
  const [q, setQ] = useState('');

  const BackdropsQ = useFuzzySearchQ(backdrops, ['id', 'name'], q);

  const BackdropsT = useMemo(() => {
    return BackdropsQ.filter((t: IShader) => {
      const okCategory = category === 'all' || t.category === category;
      const okStyle = style === 'all' || t.style === style;

      return okCategory && okStyle;
    });
  }, [BackdropsQ, category, style]);

  function onClick(item: any) {
    const verb = spawn ? 'pick' : 'playground';
    props.onAction($a('BackdropS', verb, item.id));
  }

  function onSearch(q: string) {
    setQ(q);
  }

  function onClear() {
    setQ('');
  }

  function onCategoryChange(value: string) {
    setCategrory(value);
  }

  function onStyleChange(value: string) {
    setStyle(value);
  }

  const className = classnames('BackdropBrowser-wrapper', {
    small: spawn,
  });

  return (
    <Wrapper className={className} data-testid='BackdropBrowser-wrapper'>
      <Row>
        {props.children}
        <Search q={q} onSearch={onSearch} onClear={onClear} />
        {/* <Select
          placeholder='Pick category'
          data={categories}
          size='xs'
          value={category}
          onChange={onCategoryChange}
        />
        <Segment
          value={style}
          data={styles}
          onChange={(value: string) => onStyleChange(value)}
          maxWidth={400}
        /> */}
      </Row>
      <Content>
        <VirtualGallery
          isLoading={isLoading}
          baseImageUrl=''
          items={BackdropsT}
          onClick={onClick}
          itemActions={spawn ? [] : itemActions}
          onAction={props.onAction}
          small={false}
        />
      </Content>
    </Wrapper>
  );
}

export default BackdropBrowser;
